export default "__VITE_ASSET__Dnod93H0__"